/* eslint-disable sort-keys */
/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react'

import { COLORS } from 'utils'

import { IconStyles } from '../types'
import { StatusCustom } from './styles'

// import { Container } from './styles';

interface StatusIconProps extends IconStyles {
  onClick?: any
  value?: string
}

export const colorsStatus = {
  B: COLORS.error, //BLOQUEADO
  D: COLORS.gray, //DESATIVADO
  E: COLORS.gray, //DESATIVADO
  L: COLORS.success, //LIBERADO
  P: COLORS.alert, //PENDENTE
  Pendente: COLORS.gray, //DESATIVADO
  null: COLORS.gray, //DESATIVADO
  Aprovado: COLORS.success, //LIBERADO
  Analisar: COLORS.alert, //PENDENTE
  Recusado: COLORS.error, // EXPIRADO
  Yellow: COLORS.alert,
  Green: COLORS.success,
  LightGray: COLORS.lightGray,
  Gray: COLORS.lightGray,
  Red: COLORS.error,
  Analisando: COLORS.alert,
  Liberado: COLORS.success,
  PendenteDocumento: COLORS.alert,
  Livre: COLORS.lightGray,
  Enviar: COLORS.gray
}

export const StatusIcon: React.FC<StatusIconProps> = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon,
  value
}) => {
  const colorsStatus = {
    B: COLORS.error, //BLOQUEADO
    E: COLORS.error, // VENCIDO
    D: COLORS.gray, //DESATIVADO
    L: COLORS.success, //LIBERADO
    P: COLORS.alert, //PENDENTE
    Pendente: COLORS.gray, //DESATIVADO
    null: COLORS.gray, //DESATIVADO
    Aprovado: COLORS.success, //LIBERADO
    Analisar: COLORS.alert, //PENDENTE
    Recusado: COLORS.error, // EXPIRADO
    Yellow: COLORS.alert,
    Orange: COLORS.alert,
    Green: COLORS.success,
    LightGray: COLORS.lightGray,
    lightGray: COLORS.lightGray,
    LightGrey: COLORS.lightGray,
    Gray: COLORS.lightGray,
    Red: COLORS.error,
    Analisando: COLORS.alert,
    Liberado: COLORS.success,
    PendenteDocumento: COLORS.alert,
    Livre: COLORS.lightGray,
    Enviar: COLORS.gray
  }

  return (
    <StatusCustom
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={onClick}
      colorIcon={value ? colorsStatus[value] : colorIcon}
    />
  )
}
